import {Box} from "@mui/material";
import Navbar from "./navbar/Navbar";
import HeroSection from "./HeroSection";
import FirstSection from "./FirstSection";
import EndHeroSection from "./EndHeroSection";
import FooterSection from "./FooterSection";
import CommonSection from "./CommonSection";
import {STYLE} from "./STYLES";

export default function LandingPage() {
  return (
    <Box sx={STYLE.landingPageContainer}>
      <Navbar />
      <HeroSection />
      <Box height={32} />
      <FirstSection />
      <Box height={32} />
      <CommonSection />
      <Box height={32} />
      <CommonSection />
      <Box height={48} />
      <EndHeroSection />
      <Box height={32} />
      <FooterSection />
    </Box>
  );
}
